import { Suspense, lazy, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import logo from '../assets/obraa.png';
import {
  buildMarketplacePublicUrl,
  isMarketplaceHostname,
  isObraaPrimaryHostname,
} from './marketplaceHost';
import { MARKETPLACE_PAGE_TITLE, SYSTEM_PAGE_TITLE } from './pageTitles';
import { captureVoucherLink } from '../features/partners/services/voucherLinkService';

const AppPage = lazy(() => import('../pages/App/AppPage'));
const VoucherLandingPage = lazy(() => import('../features/partners/components/VoucherLandingPage'));
const LandingPage = lazy(() => import('../pages/Landing/LandingPage'));
const MarketplaceLandingPage = lazy(() => import('../pages/Marketplace/MarketplaceLandingPage'));
const PublicMarketplacePage = lazy(() => import('../pages/Marketplace/PublicMarketplacePage'));

function usePageTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

function LandingRoute() {
  const isMarketplaceHome = isMarketplaceHostname();
  usePageTitle(isMarketplaceHome ? MARKETPLACE_PAGE_TITLE : SYSTEM_PAGE_TITLE);
  if (isMarketplaceHome) return <MarketplaceLandingPage />;
  return <LandingPage logo={logo} />;
}

function AppRoute({ routeScope }) {
  usePageTitle(SYSTEM_PAGE_TITLE);
  const location = useLocation();
  const [continuedVoucher, setContinuedVoucher] = useState('');
  const voucherId = new URLSearchParams(location.search).get('voucher');
  if (routeScope === 'app' && voucherId && voucherId !== continuedVoucher) {
    return <VoucherLandingPage voucherId={voucherId} onContinue={() => {
      captureVoucherLink();
      setContinuedVoucher(voucherId);
    }} />;
  }
  return <AppPage routeScope={routeScope} />;
}

function MarketplaceRoute() {
  usePageTitle(MARKETPLACE_PAGE_TITLE);
  const location = useLocation();
  if (isObraaPrimaryHostname()) {
    window.location.replace(buildMarketplacePublicUrl(`${location.pathname}${location.search}`));
    return null;
  }
  return <PublicMarketplacePage />;
}

export default function AppRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<LandingRoute />} />
        <Route path="/login/*" element={<AppRoute routeScope="login" />} />
        <Route path="/app/*" element={<AppRoute routeScope="app" />} />
        <Route path="/:marketplaceSlug/:listingSlug" element={<MarketplaceRoute />} />
        <Route path="/:marketplaceSlug" element={<MarketplaceRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
